"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../hooks/useLangContext");
const theme_1 = __importDefault(require("../../theme"));
const fonts_1 = require("../../theme/foundations/fonts");
const Text_1 = __importDefault(require("../_core/Text"));
const locales_1 = __importDefault(require("./locales"));
const PdfFooterComponent = ({ fiscalId, type, }) => {
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    return (react_2.default.createElement(react_1.Box, { paddingX: "space-24", width: "100%" },
        react_2.default.createElement(react_1.Box, { borderTop: "1px solid", borderTopColor: "grey.300", color: "grey.300", paddingTop: "space-4", textAlign: "right" },
            react_2.default.createElement(Text_1.default, { size: "xs" },
                locales_1.default.formatString(locales_1.default.type[type], { fiscalId }),
                locales_1.default.page,
                " ",
                react_2.default.createElement("span", { className: "pageNumber" }),
                " /",
                ' ',
                react_2.default.createElement("span", { className: "totalPages" })))));
};
const PdfFooter = ({ lang, ...props }) => (react_2.default.createElement(react_1.ChakraProvider, { theme: theme_1.default },
    react_2.default.createElement(fonts_1.Fonts, null),
    react_2.default.createElement(useLangContext_1.LangContextProvider, { lang: lang },
        react_2.default.createElement(PdfFooterComponent, { ...props }))));
exports.default = PdfFooter;
